module.exports = __webpack_public_path__ + "static/exa-6f07c5e7e8d3829d6c400355dc6d21ec.svg";